/* eslint-disable no-console */
import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(Highcharts);
import { CollectorApiService, ControllerApiService } from '@nrwl/test-setup';
import {
  HelpersService,
  LmapService,
  TestMode,
  WindowWalkService,
  LicensesPageService,
  DevicesService,
  TestListService,
  TestModeLabel
} from '@nrwl/common-lib';
import {
  ReportsTransformationService,
  TableData
} from '../../../final.test.report/services/reports.transformation.service';
import { round, isEmpty } from 'lodash';

type ChartType =
  | 'line'
  | 'column'
  | 'area'
  | 'spline'
  | 'pie'
  | 'scatter'
  | 'gauge'
  | 'arearange'
  | 'areaspline'
  | 'boxplot'
  | 'bubble';

@Component({
  selector: 'nrwl-rfc2544-reports',
  templateUrl: './rfc2544.reports.component.html',
  styleUrls: ['./rfc2544.reports.component.scss']
})
export class Rfc2544ReportsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('pdfPage') element: ElementRef;
  @Input() expertView: boolean;
  @Input() classicReport: boolean;
  @Input() reportName: string;
  @Input() chartId: string;
  @Input() reportStartTime: string;
  @Input() scheduleId: number;
  @Input() runId: number;
  @Input() testName: string;
  @Input() testData: string;
  @Input() onDemandTest: boolean;
  private readonly unsubscribe: Subject<void> = new Subject();
  overallConfiguration: any;
  shaId: string;
  configuration = {};
  serverConfig = [];
  COLOR = {
    WARNING: '#FFB500',
    MINOR: '#F08B24',
    MAJOR: '#E65E0C',
    CRITICAL: '#D50032',
    AQUA: '#13B0AB',
    PURPLE: '#9900CF',
    OCEAN_BLUE: '#3371b2',
    CERIS: '#D538C2',
    ELECTRIC_VIOLET: '#9900CF',
    TAPA: '#73726C',
    WHITE: '#FFFFFF',
    PURPLE_GRADIENT_START: 'rgba(119, 42, 201, 0.6)',
    PURPLE_GRADIENT_STOP: 'rgba(119, 42, 201, 0)',
    AQUA_GRADIENT_START: 'rgba(19, 176, 171, 0.6)',
    AQUA_GRADIENT_STOP: 'rgba(19, 176, 171, 0)',
    MINOR_GRAD_START: 'rgba(240, 139, 36, 0.6)',
    MINOR_GRAD_STOP: 'rgba(240, 139, 36, 0)',
    CRITICAL_GRAD_START: 'rgba(213, 0, 50, 0.6)',
    CRITICAL_GRAD_STOP: 'rgba(213, 0, 50, 0)'
  };

  seriesColors = [
    '#772AC9',
    '#13B0AB',
    '#87C93C',
    '#D538C2',
    '#73726C',
    '#1C9AC0',
    '#9900CF',
    '#C7C83E',
    '#27A0FF',
    '#3371b2'
  ];
  selectedOriginator: any;
  orginatorModel: null;
  licenseDetails: any = [];
  runSaturationWindow = false;
  dynamicSaturationWindow = false;
  testConfigsDataSource;
  dataSource: BehaviorSubject<any>;
  testType: string;
  requestInfo = {};
  streamNum = 0;

  loading: boolean;
  pageHeight: string;
  clientHeight: number;
  resultType: string;
  upstreamOn: boolean;
  downstreamOn: boolean;
  hasClientInfo: boolean;
  sptConfiguration = {};
  upstreamSummary = {};
  downstreamSummary = {};
  testSummary = {};
  clientInfo = {};
  rtRequestCtr: number;
  rtTotalTime: number;
  windowResults = [];
  windowSummary = [];
  dataSourceItem = [];
  irCategories: string[] = [];
  irSeriesData = [];
  irChartId = 'ir-chart';
  flCategories: string[] = [];
  flSeriesData = [];
  flChartId = 'fl-chart';
  fdCategories: string[] = [];
  fdSeriesData = [];
  fdChartId = 'fd-chart';
  fdDistributionCategories = ['< 2ms', '< 4ms', '< 8ms', '< 16ms', '< 32ms', '< 64ms', '>= 64ms'];
  fdDistributionSeriesData = [];
  fdDistributionChartId = 'fd-distribution-chart';
  fdvCategories: string[] = [];
  fdvSeriesData = [];
  fdvChartId = 'fdv-chart';

  layer = '';
  trendingInProgress = false;
  trendingComplete = false;
  trendingMsg = '';
  trendingResults = [];
  trendingPercent = 0;
  chartArray = [];
  // chartArray: Highcharts.Chart[] = [];
  chartIdArray = [];
  rptSamplesNeeded = 0;
  rptSamplesReceived = 0;
  rptRequestCtr = 0;
  rptBatchSize = 1000;
  rptStartRequestTime = new Date();
  rptLastSampleDate = null;
  rptTotalTime = 0;
  rptSampleEndTime: any;
  rptRequestRetries = 0;
  rptMaxRequestRetries = 3;
  rptSeqNumsProcessed = [];
  rptTimeOutMs = 20;
  agedout = false;
  log = false;
  testMode = 'loopback';
  fdResultsAvailable = false;
  fdvResultsAvailable = false;

  startDate = null;
  stopDate = null;
  testConfig = null;
  streams = [];
  olderConfigVersion = false;
  testConfigDisplay = {
    overall: [],
    destination: [],
    testPoints: [],
    Optimization: [],
    streams: [],
    tpaVersion: null,
    tpbVersion: null,
    ipv6Config: []
  };
  scEnabled = false;
  spEnabled = false;
  unknownText = 'Unknown';
  scResultsAvailable = false;
  spResultsAvailable = false;
  failText = 'Fail';
  overallResult = null;
  resultsNotAvailable = true;
  displayOverallResult = false;
  successText = 'Pass';
  inconclusiveText = 'Inconclusive';
  payloadTypeArray = {
    'fill-byte': 'Fill byte',
    prbs: 'PRBS'
  };
  layerToTest = '2';
  uiStreams = [];
  colors = {
    CHART_TWO_WAY_COLOR: '#28cbe0',
    CHART_NF_COLOR: '#ffba24',
    CHART_FN_COLOR: '#7b69ff',
    CHART_SLA_COLOR: '#3dd63d'
  };

  labels = {
    CHART_TWO_WAY_LABEL: 'Roundtrip Current FLR',
    CHART_NF_LABEL: 'A to B Current FLR',
    CHART_FN_LABEL: 'B to A Current FLR',
    CHART_SLA_LABEL: 'FLR Threshold',
    CHART_FD_SLA_LABEL: 'FD Threshold',
    CHART_FDV_SLA_LABEL: 'FDV Threshold',
    CHART_FD_LABEL: 'Roundtrip Current FD',
    CHART_FDV_LABEL: 'Roundtrip Current FDV'
  };

  testModeArray = {
    loopback: 'Loopback',
    unidirectional: 'Test Point A to Test Point B',
    'sequential-bidirectional': 'Sequential Bidirectional',
    'concurrent-bidirectional': 'Concurrent Bidirectional'
  };

  rtResultsRequested: number; // get all at once...max expected is < 8,000
  currentUrl: string;
  // logoUrl: string;
  message: string;
  isThinClientTest: boolean;
  thinClientTestinfo = [];
  // reportTitle: string;
  deviceType: string;
  public: boolean;
  testCapabilities: string;
  testpoints = [];
  upstreamDiagnosisMap = {};
  downstreamDiagnosisMap = {};
  diagnosisMessage = {};
  tagging = 'UNTAGGED';
  l1Rate;
  l3Rate;
  l2Rate;
  finishStatus: string;
  startRTRequestTime: Date;
  upstreamWindowResult;
  downstreamWindowResult;
  clientCpuUsage = [];
  clientMemoryUsage = [];
  displayedColumns: string[] = ['header', 'value'];
  testResultsDataSource;
  clientInfoDataSource;
  bulletChartOptions = {};
  truespeedTestResults: Array<TableData>;
  controllerStatus = '';
  streamRateConvention = 'L1 Mbps (ULR)';
  throughputInnerTableHeader = `<tr>
  <td class="throughput-inner-table-data">L1</td>
  <td class="throughput-inner-table-data">L2</td>
  <td class="throughput-inner-table-data">L3</td>
  <td class="throughput-inner-table-data">L4</td></tr>`;

  logoUrl = 'images/viavi-logo-purple.png';
  reportTitle = 'RFC2544 Test Report';
  scFinalReport: any;
  spFinalReport: any;
  spAngReport: any;
  scAngReport = [];
  showRtdOptions = false;
  formattedDate: any;
  duration: string;
  groupedReportForSc = [];
  uniqueScArray = [];
  uniqueSpArray = [];
  cirObjects: any[];
  eirScObject: any;
  eirSpObject: any;
  groupedReportForSp = [];
  policingScObject: any;
  trendChartsData = false;
  sctStepTime: string;
  sptOverallResult = [
    {
      title: 'Streams',
      value: '2'
    },
    {
      title: 'Total IR',
      value: '6',
      units: 'Mbps'
    },
    {
      title: 'Total TX Count',
      value: '228987'
    },
    {
      title: 'Total RX Count',
      value: '2567866'
    },
    {
      title: 'Total FL Count',
      value: '200000'
    },
    {
      title: 'Time Remaining',
      value: '00:00:56'
    }
  ];
  CONST = {
    THROUGHPUT: 'throughput',
    LATENCY: 'latency',
    FDV: 'fdv',
    FRAME_LOSS: 'frameLoss',
    B2B: 'b2b',
    CBS: 'cbs'
  };

  sptStreamsMetricData = [];
  SLA = {
    'ir-current': null,
    'frame-loss-ratio': null,
    'fd-current': null,
    'fdv-current': null
  };
  rtResults = [];
  metricsPresentData = {
    currentValu: null,
    unit: null,
    status: null
  };
  perTestDuration: any;
  performanceData: Array<{
    name: '';
    engineAData: {
      dataSourceItems: Array<any>;
      dataSource: BehaviorSubject<any>;
    };
    engineBData: {
      dataSourceItems: Array<any>;
      dataSource: BehaviorSubject<any>;
    };
    rxCount: any;
    frameLossCount: any;
    streamConfig: any;
    frameSize: any;
    vlanPriority: any;
    dscp: any;
  }>;
  y1564TestConfig: any;
  unitConvention: any;
  updatedTimeStamp: number;
  currentStream: any;
  tpBFlow = false;
  trendingInfoAvailable = false;
  tpAFlow: boolean;
  testStatus: any;
  testComplete: boolean;
  statusLabel: string;
  sctTestActive: boolean;
  sptTestActive: boolean;
  errorMsg: any;
  stepPercents: any;
  durationForStream: number;
  graphicMode: string;
  resultFormat_v2 = true;
  sortScAngReport: any[];
  engineACharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  engineBCharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  singleEngineCharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  qtVersion = 'v2';
  myError: any;
  errorMessage: string;
  verdictReasonAvailable = false;
  sortSpAngReport: any[];
  finalAngReport: any;
  isIpv4Test = true;
  finalResultAvailable: boolean;
  ConfigOptions: any;
  rfc2544_config: any;
  throughputTableData: any[];
  latencyTableData: any[];
  fdvTableData: any[];
  frameLossTableData: any[];
  b2bTableData: any[];
  cbsTableData: any[];
  mappedResults = {};
  testTypes = {
    throughput: { frameSize: [], successRageLow: [], successRageHigh: [], actual: [], unit: '' },
    latency: { frameSize: [], min: [], max: [], average: [], unit: '', lfc: [] },
    fdv: { frameSize: [], average: [], maxAverage: [], mPeakInstantaneousax: [], unit: '' },
    frameLoss: { frameSize: [], frameLoss: [], frameRate: [], unit: '' },
    b2b: { frameSize: [], unit: '' },
    cbs: { frameSize: [], frameSent: [], frameLost: [], unit: '' }
  };
  Highcharts: typeof Highcharts = Highcharts; // Highcharts reference

  // Chart options for each chart
  throughputChartOptions: Highcharts.Options;
  latencyChartOptions: Highcharts.Options;
  latencyCountChartOptions: Highcharts.Options;
  fdvChartOptions: Highcharts.Options;
  frameLossChartOptions: Highcharts.Options;
  cbsChartOptions: Highcharts.Options;
  reportmessage: any;
  constructor(
    private collectorApiService: CollectorApiService,
    private controllerApiService: ControllerApiService,
    private readonly helperService: HelpersService,
    private windowWalkService: WindowWalkService,
    private licenseService: LicensesPageService,
    readonly deviceService: DevicesService,
    private lmapService: LmapService,
    private testListService: TestListService,
    private transformService: ReportsTransformationService,
    private cdRef: ChangeDetectorRef
  ) {
    this.loading = false;
    this.dataSource = new BehaviorSubject<any>({ noValue: true });
    this.rtRequestCtr = 0;
    this.rtTotalTime = 0;
    this.rtResultsRequested = 10000; // get all at once...max expected is < 8,000
    this.currentUrl = window.location.href;
  }

  ngOnInit(): void {
    this.init();
    this.performanceData = [];
  }

  init(): void {
    this.loading = true;
    this.deviceType = this.windowWalkService.getDeviceType();
    this.getServerConfig();
    this.getTestConfig();
    this.getLicenseDetails();
    this.registerForResults();
    this.trendingInProgress = false;
    this.trendingComplete = false;
  }

  registerForResults(): void {
    this.controllerApiService
      .getTestList({ scheduleid: this.scheduleId, size: 1 })
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            const testEntity = this.testListService.getTestListById(this.scheduleId.toString());
            for (let x = 0; x < response.data.schedules.length; ++x) {
              if (response.data.schedules[x].runId == this.runId) {
                this.controllerStatus = response.data.schedules[x].status.toLowerCase();
                if (response.data.schedules[x].msg != 'stopped') {
                  if (testEntity.getOriginatorAgent().getModel() === 'MAP-2100') {
                    const startText = response.data.schedules[x].msg.split(':')[0];
                    const messageText = response.data.schedules[x].msg.replace(startText + ':', '');
                    const reasonMsgObj = this.isJson(messageText)
                      ? JSON.parse(messageText)
                      : messageText;
                    this.errorMessage =
                      typeof reasonMsgObj === 'object'
                        ? reasonMsgObj?.['general-error']?.['error-message']
                        : reasonMsgObj;
                  } else {
                    this.errorMessage = response.data.schedules[x].msg.split(':')[1];
                  }
                }
                break;
              }
            }
            this.processReport();
          } else {
            this.errorMessage = 'Cannot get test status from controller: ' + response.data.message;
          }
        },
        () => {
          this.loading = false;
        }
      );
  }

  isJson(str: string): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  getTestConfig(): void {
    this.controllerApiService
      .getTestConfig(this.scheduleId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            this.overallConfiguration = response.data.config;
            const agentName = this.overallConfiguration?.agent?.primary?.id;
            if (agentName) {
              this.selectedOriginator = this.deviceService.findDeviceByUniqueName(agentName);
              this.orginatorModel = this.selectedOriginator?.getModel();
            }
            this.shaId = response.data?.sha ? response.data.sha : null;
          }
        },
        () => {
          this.loading = false;
        }
      );
  }

  getServerConfig(): void {
    this.controllerApiService
      .getServerConfig()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.serverConfig = response.data;
          const serverConfig = response.data['reports'];
          if (serverConfig && serverConfig.logo && serverConfig.logo.url) {
            this.logoUrl = serverConfig.logo.url;
          }
          if (serverConfig && serverConfig.message) {
            this.reportmessage = serverConfig.message;
          }
        },
        () => (this.loading = false)
      );
  }
  getLicenseDetails(): void {
    this.licenseService
      .getLicenseCount()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          this.licenseDetails = response;
        },
        () => (this.loading = false)
      );
  }

  // ToDo return type and parameter can be typed while integrated with backend.
  // eslint-disable-next-line
  processReport(): any {
    this.collectorApiService
      .getQueryReportByFromTime(this.scheduleId, this.runId, 'final', this.reportStartTime, 5)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          if (response.status === 'success') {
            response.data = response.data.filter(data => {
              const instanceStartTime = this.lmapService.getTagValue(
                data['ietf-lmap-report:report'].result[0].tag,
                'instance-start-time'
              );
              return instanceStartTime === this.reportStartTime;
            });
            this.errorMsg = this.helperService.getResponseErrorMsg(response);
            if (!this.errorMsg) {
              if (response.data) {
                if (response.log) {
                  console.log('plugin: Got Test List: ', JSON.stringify(response));
                }
                //overriding test config with current testid config
                const currentRunConfig = this.getTestConfigOption(response.data);
                if (!isEmpty(currentRunConfig)) {
                  this.overallConfiguration.config[0].primaryConfig[
                    'ietf-lmap-control:lmap'
                  ].schedules.schedule[0].action[0].option = currentRunConfig;
                }
                if (this.overallConfiguration) {
                  const config = this.lmapService.getTestOptions(
                    'rfc2544',
                    ['rfc2544'],
                    this.overallConfiguration
                  );
                  if (config && config.rfc2544) {
                    this.testConfig = JSON.parse(config.rfc2544);
                  }
                } else {
                  console.log(
                    'RFC2544 final report: Cannot create configuration section - controller configuration is not present'
                  );
                }

                if (this.testConfig) {
                  const rfcConfig = this.testConfig['rfc2544-viavi'].config;
                  if (
                    rfcConfig &&
                    (rfcConfig['layer3-ipv6'] ||
                      (rfcConfig['layer2'] &&
                        rfcConfig['layer2']['destination-ip'] &&
                        rfcConfig['layer2']['destination-ip'].includes(':')))
                  ) {
                    this.isIpv4Test = false;
                  }

                  if (this.testConfigDisplay?.overall?.length === 0) {
                    this.createOverallTestSetup(response);
                    this.setFinalResultData(response);
                  }

                  this.startDate = null;
                  this.stopDate = null;
                  if (response && response.data && response.data.length) {
                    response.data.forEach((item: any) => {
                      const report = item['ietf-lmap-report:report'];
                      if (report) {
                        const myStopDate = new Date(report.date);
                        if (!this.stopDate || myStopDate.getTime() > this.stopDate.getTime()) {
                          this.stopDate = myStopDate;
                        }
                        if (!this.startDate && report.result && report.result.length > 0) {
                          this.startDate = new Date(report.result[0].start);
                        }
                      }
                    });
                  }
                } else {
                  console.log(
                    'RFC2544 final report: Cannot create configuration section - test configuration is not present'
                  );
                }

                this.processStartStopDates();
                this.requestInfo = this.createRequestInfo(this.overallConfiguration);

                let angularFinalResult = null;
                if (response && typeof response.data === 'object') {
                  angularFinalResult = this.lmapService.ltranslateLmapReportIndexToAngular(
                    response.data
                  );
                }
                this.finalAngReport = angularFinalResult;

                let result = this.successText;

                if (this.finalAngReport) {
                  this.finalResultAvailable = true;
                  result = this.getVerdict(this.finalAngReport);
                } else {
                  this.finalResultAvailable = true;
                }
                if (
                  this.controllerStatus === 'finished' ||
                  this.controllerStatus === 'running' ||
                  this.controllerStatus === 'scheduled'
                ) {
                  this.overallResult = result;
                } else {
                  this.overallResult = 'unknown';
                }

                if (!this.finalResultAvailable) {
                  this.resultsNotAvailable = true;
                } else {
                  this.resultsNotAvailable = false;
                  this.displayOverallResult = true;
                }
                if (this.overallResult === this.failText) {
                  this.myError = this.produceErrorObj(this.finalAngReport);
                  if (this.myError) {
                    this.errorMessage = this.myError + '.';
                  }
                }
              } else {
                console.log(
                  this.helperService.getCurrentTimeDate() + ' response.data does not exist'
                );
              }
            } else {
              this.resultsNotAvailable = true;
            }

            this.initializeCharts();
          }
        },
        () => (this.loading = false)
      );
    this.loading = false;
  }

  //eslint-disable-next-line
  produceErrorObj(finalReport) {
    let errMsg = null;
    let packetLossErrorCount = 0;
    let jitterErrorCount = 0;
    const multipleStreamsFailed = false;
    if (finalReport != null) {
      for (let i = 0, len = finalReport.length; i < len; ++i) {
        let packetLossFailed = false;
        let jitterFailed = false;
        const report = finalReport[i];
        if (report && report['verdict'] === 'fail') {
          if (report['packet-loss-ratio-verdict'] === 'fail') {
            packetLossFailed = true;
            packetLossErrorCount++;
          }
          if (report['jitter-verdict'] === 'fail') {
            jitterFailed = true;
            jitterErrorCount++;
          }
        }
      }
    }

    // Produce an error message
    if (packetLossErrorCount > 0 || jitterErrorCount > 0) {
      if (multipleStreamsFailed) {
        errMsg = 'Multiple test failures occurred. Please review report for more details';
      }
      if (errMsg !== null) {
        let reason = '';
        if (packetLossErrorCount > 0) {
          reason += ' packet loss threshold exceeded';
        }
        if (jitterErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'Jitter threshold exceeded';
        }
        errMsg += ' failed due to ' + reason;
      }
    }
    return errMsg;
  }

  //eslint-disable-next-line
  createRequestInfo(data: any): any {
    const requestInfo = {};
    if (data && data?.test?.['extended-config']) {
      requestInfo['technicianName'] = data.test['extended-config']?.technicianInfo.name;
      requestInfo['technicianId'] = data.test['extended-config']?.technicianInfo.id;
      requestInfo['mode'] = data.test['extended-config']?.test.mode.toUpperCase();
      requestInfo['comments'] = data.test['extended-config']?.testInfo.comments;
    }

    if (data && data?.test?.['test-list-data']) {
      requestInfo['customerInfo'] = data?.test?.['test-list-data']?.customer;
      requestInfo['mode'] = data?.test?.['test-list-data']?.mode?.toUpperCase();
    }
    let agentName = data?.agent?.primary?.id ? data.agent.primary.id : null;
    if (!agentName && data?.test?.['extended-config']?.testPoints) {
      agentName =
        data?.test?.['extended-config']?.testPoints?.length > 0
          ? data.test['extended-config'].testPoints[0].name
          : null;
    }
    return requestInfo;
  }

  initializeCharts(): void {
    if (this.testTypes.throughput.frameSize.length)
      this.throughputChartOptions = this.buildThroughputChart();
    if (this.latencyTableData) {
      if (this.testTypes.latency.frameSize.length)
        this.latencyChartOptions = this.buildLatencyChart();
      if (this.testTypes.latency.lfc.length)
        this.latencyCountChartOptions = this.buildLatencyCountChart();
    }
    if (this.testTypes.fdv.frameSize.length) this.fdvChartOptions = this.buildFDVChart();
    if (this.testTypes.frameLoss.frameSize.length)
      this.frameLossChartOptions = this.buildFrameLossChart();
    if (this.testTypes.cbs.frameSize.length) this.cbsChartOptions = this.buildCBSChart();
    // this.cdRef.detectChanges();
    this.initHighChart();
  }

  initHighChart(): any {
    if (this.throughputChartOptions?.series?.length)
      Highcharts.chart('throughputChart', this.throughputChartOptions);
    if (this.latencyChartOptions?.series?.length)
      Highcharts.chart('latencyChart', this.latencyChartOptions);
    if (this.latencyCountChartOptions?.series?.length)
      Highcharts.chart('latencyFrameCountChart', this.latencyCountChartOptions);
    if (this.fdvChartOptions?.series?.length) Highcharts.chart('fdvChart', this.fdvChartOptions);
    if (this.frameLossChartOptions?.series?.length)
      Highcharts.chart('frameLossChart', this.frameLossChartOptions);
    if (this.cbsChartOptions?.series?.length) Highcharts.chart('cbsChart', this.cbsChartOptions);
  }

  buildThroughputChart(): Highcharts.Options {
    return {
      chart: { type: 'column' },
      title: { text: 'Throughput Statistics' },
      colors: this.seriesColors,
      xAxis: {
        categories: this.testTypes.throughput.frameSize.map(size => `${size} bytes`),
        title: { text: 'Frame Size' }
      },
      yAxis: {
        title: { text: 'Throughput (Mbps)' }
      },
      plotOptions: {
        column: {
          minPointLength: 3,
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.15, // Adjust space between groups
          dataLabels: {
            enabled: false
          }
        }
      },
      series: [
        {
          type: 'column',
          name: 'Actual Throughput',
          data: this.testTypes.throughput.actual,
          color: '#3371b2'
        },
        {
          type: 'spline',
          name: 'Success Range Low',
          data: this.testTypes.throughput.successRageLow,
          color: '#90ed7d'
        },
        {
          type: 'spline',
          name: 'Success Range High',
          data: this.testTypes.throughput.successRageHigh,
          color: '#2b908f'
        }
      ]
    };
  }

  buildLatencyChart(): Highcharts.Options {
    return {
      chart: { type: 'line' },
      title: { text: 'Latency Statistics' },
      colors: this.seriesColors,
      xAxis: {
        categories: this.testTypes.latency.frameSize.map(size => `${size} bytes`),
        title: { text: 'Frame Size' }
      },
      yAxis: {
        title: { text: 'Latency (μsec)' }
      },
      plotOptions: {
        column: {
          minPointLength: 3,
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.15, // Adjust space between groups
          dataLabels: {
            enabled: false
          }
        }
      },
      series: [
        {
          type: 'column',
          name: 'Minimum Latency',
          data: this.testTypes.latency.min,
          color: '#3371b2'
        },
        {
          type: 'column',
          name: 'Average Latency',
          data: this.testTypes.latency.average,
          color: '#90ed7d'
        },
        {
          type: 'column',
          name: 'Maximum Latency',
          data: this.testTypes.latency.max,
          color: '#2b908f'
        }
      ]
    };
  }

  buildLatencyCountChart(): Highcharts.Options {
    const latencyData = this.testTypes.latency; // Using the structured latency data

    // Prepare series array where each series represents a frame size
    const series: Highcharts.SeriesOptionsType[] = latencyData.frameSize.map((size, index) => {
      // Collect data for this frame size across all latency intervals
      const data = latencyData.lfc.map(category => latencyData[category][index]);

      return {
        type: 'column',
        name: `${size} bytes`,
        data: data,
        color: this.seriesColors[index % this.seriesColors.length]
      };
    });

    return {
      chart: {
        type: 'column'
      },
      title: {
        text: 'Latency Frame Count'
      },
      colors: this.seriesColors,
      xAxis: {
        categories: latencyData.lfc, // Latency intervals as x-axis categories
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Frame Count'
        }
      },
      plotOptions: {
        column: {
          minPointLength: 3,
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.15, // Adjust space between groups
          dataLabels: {
            enabled: false
          }
        }
      },
      series: series
    };
  }

  buildFDVChart(): Highcharts.Options {
    const categories = this.testTypes.fdv.frameSize.map(size => `${size} bytes`);
    const avgFDVData = this.testTypes.fdv.average;
    const maxFDVData = this.testTypes.fdv.maxAverage;
    const mPeakFDVData = this.testTypes.fdv.mPeakInstantaneousax;

    return {
      chart: { type: 'column' },
      title: { text: 'Frame Delay Variation' },
      xAxis: { categories: categories, title: { text: 'Frame Size' } },
      yAxis: { title: { text: 'FDV (ms)' } },
      plotOptions: {
        column: {
          minPointLength: 3,
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.15, // Adjust space between groups
          dataLabels: {
            enabled: false
          }
        }
      },
      series: [
        { type: 'column', name: 'Average FDV', data: avgFDVData, color: '#3371b2' },
        { type: 'column', name: 'Max FDV', data: maxFDVData, color: '#90ed7d' },
        { type: 'column', name: 'Peak Instantaneous', data: mPeakFDVData, color: '#2b908f' }
      ],
      credits: { enabled: false }
    };
  }

  buildFrameLossChart(): Highcharts.Options {
    const categories = this.testTypes.frameLoss.frameSize.map(size => `${size} bytes`);
    const frameLossData = this.testTypes.frameLoss.frameLoss;
    const frameRateData = this.testTypes.frameLoss.frameRate;

    return {
      chart: { type: 'column' },
      title: { text: 'Frame Rate vs Frame Loss' },
      xAxis: { categories: categories, title: { text: 'Frame Size' } },
      yAxis: { title: { text: 'Percentage (%)' }, min: 0 },
      plotOptions: {
        column: {
          minPointLength: 3, // Minimum point length to show zero value bars
          borderWidth: 0, // Optional: adjust border width for visibility
          dataLabels: {
            enabled: true, // Optionally enable data labels
            formatter: function () {
              return this.y > 0 ? this.y : null; // Display labels only for non-zero values
            }
          }
        }
      },
      series: [
        { type: 'column', name: 'Frame Loss', data: frameLossData, color: '#3371b2' },
        { type: 'spline', name: 'Frame Rate', data: frameRateData, color: '#2b908f' }
      ],
      credits: { enabled: false }
    };
  }

  buildCBSChart(): Highcharts.Options {
    const categories = this.testTypes.cbs.frameSize.map(size => `${size} bytes`);
    const framesSentData = this.testTypes.cbs.frameSent;
    const framesLostData = this.testTypes.cbs.frameLost;

    return {
      chart: { type: 'column' },
      title: { text: 'Committed Burst Size Statistics' },
      xAxis: { categories: categories, title: { text: 'Frame Size' } },
      yAxis: { title: { text: 'Frames Count' } },
      plotOptions: {
        column: {
          minPointLength: 3,
          pointPadding: 0.1,
          borderWidth: 0,
          groupPadding: 0.15, // Adjust space between groups
          dataLabels: {
            enabled: false
          }
        }
      },
      series: [
        { type: 'column', name: 'Frames Sent', data: framesSentData, color: '#3371b2' },
        { type: 'column', name: 'Frames Lost', data: framesLostData, color: '#2b908f' }
      ],
      credits: { enabled: false }
    };
  }

  roundNumericValues(values: any[]): any {
    return values.map(val =>
      !isNaN(parseFloat(val)) ? round(parseFloat(val), 3).toString() : val
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setFinalResultData(tableData: any) {
    if (tableData.data) {
      tableData.data.forEach((dataItem: any) => {
        const result = dataItem['ietf-lmap-report:report']['result'][0];
        result.tag.forEach((tag: string, rIndex: number) => {
          const table = result.table[0];

          if (tag === 'table-type:throughput' && table.row.length !== 0) {
            this.throughputTableData = [];
            this.throughputTableData.push(table.column);
            table.row.forEach((rowItem: any) => {
              const value = rowItem.value;
              if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                value[0] = '82';
              }
              this.throughputTableData.push(this.roundNumericValues(value));
            });
          }

          if (tag === 'table-type:latency' && table.row.length !== 0) {
            this.latencyTableData = [];
            if (this.selectedOriginator?.getModel() === 'MAP-2100') {
              this.processLatencyTableDataForMap2100(table);
            } else {
              this.latencyTableData.push(table.column);
              table.row.forEach((rowItem: any) => {
                const value = rowItem.value;
                if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                  value[0] = '82';
                }
                this.latencyTableData.push(this.roundNumericValues(value));
              });
            }
          }

          if (tag === 'table-type:fdv' && table.row.length !== 0) {
            this.fdvTableData = [];
            this.fdvTableData.push(table.column);
            table.row.forEach((rowItem: any) => {
              const value = rowItem.value;
              if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                value[0] = '82';
              }
              this.fdvTableData.push(this.roundNumericValues(value));
            });
          }

          if (tag === 'table-type:frameloss' && table.row.length !== 0) {
            this.frameLossTableData = [];
            this.frameLossTableData.push(table.column);
            table.row.forEach((rowItem: any) => {
              const value = rowItem.value;
              if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                value[0] = '82';
              }
              this.frameLossTableData.push(this.roundNumericValues(value));
            });
          }

          if (tag === 'table-type:backtoback' && table.row.length !== 0) {
            this.b2bTableData = [];
            this.b2bTableData.push(table.column);
            table.row.forEach((rowItem: any) => {
              const value = rowItem.value;
              if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                value[0] = '82';
              }
              this.b2bTableData.push(this.roundNumericValues(value));
            });
          }

          if (tag === 'table-type:cbs' && table.row.length !== 0) {
            this.cbsTableData = [];
            this.cbsTableData.push(table.column);
            table.row.forEach((rowItem: any) => {
              const value = rowItem.value;
              if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
                value[0] = '82';
              }
              this.cbsTableData.push(this.roundNumericValues(value));
            });
          }
        });
      });

      // Process the final results into key-value pairs and collect graph data
      this.buildResultMapAndGraphData();
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processLatencyTableDataForMap2100(table: any) {
    const removeLatencyBinningColumns: any[] = [];
    const tableDataColumns = table.column;

    // Filter out latency binning columns
    tableDataColumns.forEach((column: string) => {
      if (
        ![
          'Count of frames with latency < 2 ms',
          '2 ms <= latency < 4 ms',
          '4 ms <= latency < 8 ms',
          '8 ms <= latency < 16 ms',
          '16 ms <= latency < 32 ms',
          '32 ms <= latency < 64 ms',
          'Count of frames with latency >=64 ms'
        ].includes(column)
      ) {
        removeLatencyBinningColumns.push(column);
      }
    });

    this.latencyTableData.push(removeLatencyBinningColumns);

    // Add rows of latency data
    table.row.forEach((rowItem: any) => {
      const value = rowItem.value;
      if (!this.isIpv4Test && value && value.length > 0 && value[0] === '64') {
        value[0] = '82';
      }
      const removeLatencyBinningRows: any[] = [];
      removeLatencyBinningColumns.forEach((_: any, index: number) => {
        removeLatencyBinningRows.push(value[index]);
      });
      this.latencyTableData.push(removeLatencyBinningRows);
    });
  }

  buildResultMapAndGraphData(): void {
    if (this.throughputTableData) {
      this.buildResultMap('THROUGHPUT', this.throughputTableData);
      this.collectGraphData('THROUGHPUT', this.mappedResults['THROUGHPUT']);
    } else {
      this.testTypes['THROUGHPUT'] = null;
    }

    if (this.latencyTableData) {
      this.buildResultMap('LATENCY', this.latencyTableData);
      this.collectGraphData('LATENCY', this.mappedResults['LATENCY']);
    } else {
      this.testTypes['LATENCY'] = null;
    }

    if (this.fdvTableData) {
      this.buildResultMap('FDV', this.fdvTableData);
      this.collectGraphData('FDV', this.mappedResults['FDV']);
    } else {
      this.testTypes['FDV'] = null;
    }

    if (this.frameLossTableData) {
      this.buildResultMap('FRAME_LOSS', this.frameLossTableData);
      this.collectGraphData('FRAME_LOSS', this.mappedResults['FRAME_LOSS']);
    } else {
      this.testTypes['FRAME_LOSS'] = null;
    }

    if (this.cbsTableData) {
      this.buildResultMap('CBS', this.cbsTableData);
      this.collectGraphData('CBS', this.mappedResults['CBS']);
    } else {
      this.testTypes['CBS'] = null;
    }
  }

  // Stub methods for buildResultMap and buildGraphData, assuming they exist in the original code
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  buildResultMap(resultName: string, tableData: any[]) {
    const resultsMap: any = {};

    for (let j = 0; j < tableData[0].length; j++) {
      const results: number[] = [];
      for (let i = 1; i < tableData.length; i++) {
        results.push(this.convertToNumber(tableData[i][j]));
      }
      resultsMap[tableData[0][j]] = results;
    }

    this.mappedResults[resultName] = resultsMap;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  collectGraphData(testType: string, tableData: any) {
    let testTypesValue = testType.toLowerCase();
    if (testTypesValue === 'frame_loss') testTypesValue = 'frameLoss';
    if (this.testTypes[testTypesValue]) {
      this.testTypes[testTypesValue].frameSize = this.getColunmValue(tableData, 'Frame Size');
    }

    if (this.CONST.THROUGHPUT === testTypesValue) {
      this.testTypes[testTypesValue].actual = this.getColunmValue(tableData, 'Actual Max');
      this.testTypes[testTypesValue].successRageLow = this.getColunmValue(
        tableData,
        'Success Range Low Bound'
      );
      this.testTypes[testTypesValue].successRageHigh = this.getColunmValue(
        tableData,
        'Success Range High Bound'
      );
      this.testTypes[testTypesValue].unit = this.getUnitName(tableData, 'Success Range Low Bound');
    } else if (this.CONST.FDV === testTypesValue) {
      this.testTypes[testTypesValue].average = this.getColunmValue(
        tableData,
        'Average Frame Delay Variation'
      );
      this.testTypes[testTypesValue].maxAverage = this.getColunmValue(tableData, 'Max Average FDV');
      this.testTypes[testTypesValue].mPeakInstantaneousax = this.getColunmValue(
        tableData,
        'Peak Instantaneous FDV'
      );
      this.testTypes[testTypesValue].unit = this.getUnitName(tableData, 'Peak Instantaneous FDV');
    } else if (this.CONST.FRAME_LOSS === testTypesValue) {
      this.testTypes[testTypesValue].frameLoss = this.getColunmValue(tableData, 'Frame Loss (%)');
      this.testTypes[testTypesValue].frameRate = this.getColunmValue(
        tableData,
        'Frame Rate Percent (% of theoretical maximum)'
      );
      this.testTypes[testTypesValue].unit = ' Percent';
    } else if (this.CONST.LATENCY === testTypesValue) {
      this.testTypes[testTypesValue].min = this.getColunmValue(tableData, 'Minimum Latency');
      this.testTypes[testTypesValue].max = this.getColunmValue(tableData, 'Maximum Latency');
      this.testTypes[testTypesValue].average = this.getColunmValue(tableData, 'Average Latency');
      this.testTypes[testTypesValue].unit = this.getUnitName(tableData, 'Average Latency');
      const intervals = this.getLatecyTimeIntervals(tableData);

      intervals.forEach(interval => {
        if (!this.testTypes[testTypesValue][interval.name]) {
          this.testTypes[testTypesValue][interval.name] = [];
        }
        this.testTypes[testTypesValue][interval.name] = this.getColunmValue(
          tableData,
          interval.key
        );
      });
    } else if (this.CONST.CBS === testTypesValue) {
      this.testTypes[testTypesValue].frameSent = this.getColunmValue(tableData, 'Frames Sent');
      this.testTypes[testTypesValue].frameLost = this.getColunmValue(tableData, 'Frames Lost');
      this.testTypes[testTypesValue].unit = '';
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertToNumber(value: any): number {
    if (value) {
      const num = Number(value);
      return isNaN(num) ? value : num;
    }
    return 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getColunmValue(resultMap: any, columnName: string): any {
    for (const key in resultMap) {
      if (key.includes(columnName)) {
        return resultMap[key];
      }
    }
    return '';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getLatecyTimeIntervals(tableData: any): any[] {
    const latencyTest: any[] = [];

    for (const key in tableData) {
      if (key.includes('latency <')) {
        const intervalName = '<' + key.split('latency <')[1];
        latencyTest.push({ key, name: intervalName });
        if (!this.testTypes[this.CONST.LATENCY].lfc) {
          this.testTypes[this.CONST.LATENCY].lfc = [];
        }
        this.testTypes[this.CONST.LATENCY].lfc.push(intervalName);
      } else if (key.includes('latency >')) {
        const intervalName = '>' + key.split('latency >')[1];
        latencyTest.push({ key, name: intervalName });
        if (!this.testTypes[this.CONST.LATENCY].lfc) {
          this.testTypes[this.CONST.LATENCY].lfc = [];
        }
        this.testTypes[this.CONST.LATENCY].lfc.push(intervalName);
      }
    }
    return latencyTest;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getUnitName(tableData: any, columnName: string): string {
    for (const key in tableData) {
      if (key.includes(columnName)) {
        return ' ' + key.substring(key.lastIndexOf('(') + 1, key.lastIndexOf(')'));
      }
    }
    return '';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processStartStopDates() {
    function padZero(x) {
      return x < 10 ? '0' + x : x.toString();
    }
    if (this.stopDate && this.startDate) {
      let diffTime = this.stopDate.getTime() - this.startDate.getTime();
      diffTime = diffTime / 1000;

      let minutes = Math.floor(diffTime / 60);
      const seconds = diffTime % 60;
      let hours = 0;
      if (minutes >= 60) {
        hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
      }
      let days = 0;
      if (hours >= 24) {
        days = Math.floor(hours / 24);
        hours = hours % 24;
      }

      this.duration =
        (days ? days + 'd ' : '') +
        (hours ? hours + 'h ' : '') +
        (minutes ? minutes + 'm ' : '') +
        seconds +
        's';
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getVerdict(angularReport) {
    let verdict = this.unknownText;

    for (const x in angularReport) {
      for (const y in angularReport[x]) {
        if (y === 'verdict-reason' && angularReport[x][y]) {
          this.errorMessage = angularReport[x][y];
        }
        if (typeof y === 'string' && y === 'verdict') {
          switch (angularReport[x][y]) {
            case 'pass':
              verdict = this.successText;
              break;
            case 'fail':
              verdict = this.failText;
              break;
            case 'inconclusive':
              verdict = this.inconclusiveText;
              break;
            default:
              verdict = this.successText;
              break;
          }
        }
      }

      if (verdict === this.failText || verdict === this.inconclusiveText) {
        break;
      }
    }

    return verdict;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createOverallTestSetup(tableData: any): void {
    if (this.testConfig && this.testConfig['rfc2544-viavi']) {
      if (tableData.data[0]['ietf-lmap-report:report']['result'][0]['option']) {
        this.ConfigOptions = tableData.data[0]['ietf-lmap-report:report']['result'][0]['option'];
        for (const option of this.ConfigOptions) {
          if (option.id === 'rfc2544') {
            this.rfc2544_config = JSON.parse(option.value)['rfc2544-viavi']['config'];
          }
        }

        this.handleOptions();
      }
    }
  }

  handleOptions(): void {
    for (const option of this.ConfigOptions) {
      switch (option.id) {
        case 'source-ip':
          if (this.rfc2544_config['layer3-ipv4'] || this.rfc2544_config['layer3-ipv6']) {
            this.testConfigDisplay.testPoints.push({ name: 'Test Address', value: option.value });
          }
          break;
        case 'subnet':
          this.testConfigDisplay.testPoints.push({ name: 'Test Subnet Mask', value: option.value });
          break;
        case 'prefix-length':
          this.testConfigDisplay.testPoints.push({ name: 'Prefix length ', value: option.value });
          break;
        case 'gateway':
          this.testConfigDisplay.testPoints.push({ name: 'Test Gateway', value: option.value });
          break;
        case 'vlan-id':
          this.testConfigDisplay.testPoints.push({ name: 'S-VLAN', value: option.value });
          break;
        case 'vlan-priority':
          this.testConfigDisplay.testPoints.push({ name: 'S-VLAN priority', value: option.value });
          break;
        case 'inner-vlan-id':
          this.testConfigDisplay.testPoints.push({ name: 'C-VLAN', value: option.value });
          break;
        case 'inner-vlan-priority':
          this.testConfigDisplay.testPoints.push({ name: 'C-VLAN priority', value: option.value });
          break;
        case 'ether-type':
          this.testConfigDisplay.testPoints.push({ name: 'Ether Type', value: option.value });
          break;
        case 'max-line-rate-for-test':
          this.testConfigDisplay.overall.push({
            name: 'Max Line rate',
            value: option.value + '  Mbps'
          });
          break;
        case 'phy-id':
          if (option.value === 'p1') {
            this.testConfigDisplay.overall.push({ name: 'Test Port', value: 'Port1' });
          } else if (option.value === 'p2') {
            this.testConfigDisplay.overall.push({ name: 'Test Port', value: 'Port2' });
          }
          break;
        case 'rfc2544':
          this.handleRFC2544Config();
          break;
      }
    }
  }

  handleRFC2544Config(): void {
    this.testConfigDisplay.overall.push({ name: 'Test Mode', value: 'Loopback' });
    if (this.rfc2544_config['loopback-device'] === 'other') {
      this.testConfigDisplay.overall.push({ name: 'Loop UP', value: 'Disabled' });
    } else {
      this.testConfigDisplay.overall.push({ name: 'Loop UP', value: 'Enabled' });
    }
    if (this.rfc2544_config['layer3-ipv4']) {
      this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 3' });
      this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' });
      this.testConfigDisplay.destination.push({
        name: 'IP Address',
        value: this.rfc2544_config['layer3-ipv4']['destination-ip']
      });
    }
    if (this.rfc2544_config['layer3-ipv6']) {
      this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 3' });
      this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV6' });
      this.testConfigDisplay.destination.push({
        name: 'IP Address',
        value: this.rfc2544_config['layer3-ipv6']['destination-ip']
      });
      this.testConfigDisplay.overall.push({
        name: 'Traffic Class',
        value: this.rfc2544_config['layer3-ipv6']['traffic-class']
      });
      this.testConfigDisplay.overall.push({
        name: 'Flow Label',
        value: this.rfc2544_config['layer3-ipv6']['flow-label']
      });
      this.testConfigDisplay.overall.push({
        name: 'Hop Limit',
        value: this.rfc2544_config['layer3-ipv6']['hop-limit']
      });
    }
    if (this.rfc2544_config['layer2']) {
      this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 2' });
      this.testConfigDisplay.destination.push({
        name: 'MAC ',
        value: this.rfc2544_config['layer2']['destination-mac']
      });
    }
    this.streamRateConvention =
      this.rfc2544_config['unit-convention'] === 'l1-mbps' ? 'L1 Mbps (ULR)' : 'L2 Mbps (IR)';
    this.testConfigDisplay.overall.push({
      name: 'Stream Rate Convention',
      value: this.streamRateConvention
    });
    this.testConfigDisplay.overall.push({
      name: 'Remote VLAN tag count',
      value: this.rfc2544_config['remote-vlan-tag-count']
    });
    this.testConfigDisplay.overall.push({
      name: 'Network Overhead',
      value: this.rfc2544_config['network-overhead']
    });

    if (
      this.rfc2544_config['throughput'] &&
      this.rfc2544_config['throughput']['stop-on-throughput-fail']
    ) {
      this.testConfigDisplay.Optimization.push({
        name: 'Stop overall RFC 2544 test if Throughput test fails',
        value: this.rfc2544_config['throughput']['stop-on-throughput-fail']
      });
    }
    if (
      this.rfc2544_config['frameloss'] &&
      this.rfc2544_config['frameloss']['skip-if-throughput-pass']
    ) {
      this.testConfigDisplay.Optimization.push({
        name: 'Run Frame Loss test only if Throughput test fails',
        value: this.rfc2544_config['frameloss']['skip-if-throughput-pass']
      });
    }
    if (this.rfc2544_config['cir']) {
      this.testConfigDisplay.streams.push({
        name: 'CIR',
        value: this.rfc2544_config['cir'] + ' Kbps'
      });
    }
    if (this.rfc2544_config['frame-size-info']) {
      this.testConfigDisplay.streams.push({ name: 'Frame Size', value: this.getSelectedFrames() });
    }
    if (this.rfc2544_config['layer3-ipv4'] && this.rfc2544_config['layer3-ipv4']['tos-or-dscp']) {
      this.testConfigDisplay.streams.push({
        name: 'Tos/DiffServ',
        value: this.rfc2544_config['layer3-ipv4']['tos-or-dscp']
      });
    }
    if (this.rfc2544_config['layer3-ipv4'] && this.rfc2544_config['layer3-ipv4']['filter-on-tos']) {
      this.testConfigDisplay.streams.push({
        name: 'Verify Received ToS/DiffServ',
        value: this.rfc2544_config['layer3-ipv4']['filter-on-tos']
      });
    }
    if (this.rfc2544_config['layer3-ipv6'] && this.rfc2544_config['layer3-ipv6']['flow-label']) {
      this.testConfigDisplay.streams.push({
        name: 'Flow Label',
        value: this.rfc2544_config['layer3-ipv6']['flow-label']
      });
    }
    if (this.rfc2544_config['layer3-ipv6'] && this.rfc2544_config['layer3-ipv6']['traffic-class']) {
      this.testConfigDisplay.streams.push({
        name: 'Traffic Class',
        value: this.rfc2544_config['layer3-ipv6']['traffic-class']
      });
    }
    if (this.rfc2544_config['layer3-ipv6'] && this.rfc2544_config['layer3-ipv6']['hop-limit']) {
      this.testConfigDisplay.streams.push({
        name: 'Hop Limit',
        value: this.rfc2544_config['layer3-ipv6']['hop-limit']
      });
    }
  }

  getSelectedFrames(): string {
    const selectedFrames: string[] = [];

    // Loop through the frame-size-info object
    for (const key in this.rfc2544_config['frame-size-info']) {
      if (
        Object.prototype.hasOwnProperty.call(this.rfc2544_config['frame-size-info'], key) &&
        this.rfc2544_config['frame-size-info'][key] === 'true'
      ) {
        selectedFrames.push(key.split('use-frame-size-')[1]);
      }
    }

    // Add custom frame size if available
    if (this.rfc2544_config['frame-size-info']['custom-frame-size']) {
      selectedFrames.push(this.rfc2544_config['frame-size-info']['custom-frame-size']);
    }

    // Return the frames as a comma-separated string
    return selectedFrames.toString();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.expertView) {
      this.expertView = changes.expertView.currentValue;
    }
    if (changes && (changes.runId || changes.reportStartTime)) {
      this.requestInfo = {};
      this.upstreamSummary = {};
      this.downstreamSummary = {};
      this.testSummary = {};
      this.clientInfo = {};
      this.windowResults = [];
      this.windowSummary = [];
      this.configuration = {};
      this.upstreamWindowResult = null;
      this.downstreamWindowResult = null;
      this.overallResult = null;
      this.errorMessage = null;
      this.uiStreams = [];
      this.testConfigDisplay = {
        overall: [],
        destination: [],
        testPoints: [],
        Optimization: [],
        streams: [],
        tpaVersion: null,
        tpbVersion: null,
        ipv6Config: []
      };
      this.init();
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    if (this.log) {
      console.log('DESTROY');
    }

    this.chartArray.forEach(chart => {
      chart.destroy();
    });
    this.chartArray = [];

    this.chartIdArray.forEach(id => {
      const chartElem = document.getElementById(id);
      if (chartElem) {
        while (chartElem.firstChild) {
          chartElem.removeChild(chartElem.firstChild);
        }
      }
    });
    this.chartIdArray = [];

    this.trendingInProgress = false;
  }

  //eslint-disable-next-line
  getTestConfigOption(response): any {
    let optionValue = [];
    if (response.length) {
      const reports = response[0];
      const testOptions = reports['ietf-lmap-report:report'].result[0].option;
      optionValue = testOptions;
    }
    return optionValue;
  }
}
